import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapLocationDot, faCalendarDays, faRankingStar } from '@fortawesome/free-solid-svg-icons';
import Slider from "react-slick";
import { api } from '../AppConfig';
import { motion } from 'motion/react';
import front_image from '../assets/banner_lpi.png';
import TournamentCard from '../components/TournamentCard';
import { useTranslation } from 'react-i18next';

function Home(props) {
  const [upcoming, setUpcoming] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);
  const [messageApi, contextHolder] = message.useMessage();
  const basepath = process.env.PUBLIC_URL
  ? `${process.env.PUBLIC_URL}`
  : '/'; 
  const { t } = useTranslation();

  // console.warn('width attuale: ', width);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
      fetch(api.tournaments().upcoming().href)
      .then(res => res.json())
      .then(
        (result) => {
          setUpcoming(result.payLoad);
        },
        (error) => {
          messageApi.error('There was an error fetching upcoming tournaments! Retry later.')
          // setError(error); 
        }
      )
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
      };
  }, [])

  const isMobile = width <= 768;

  // Settings for the carousel
  let carouselSettings = {};
  if (isMobile) {
    // console.warn('settings for mobile!')
    carouselSettings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 2
    };
  } else {
    // console.warn('settings for desktop!')
    carouselSettings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4
    };
  }

  // console.warn('carouselSettings:', carouselSettings)
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}>
    {contextHolder}
    <div 
      className="banner-home" 
      style={{ backgroundImage: `url(${front_image})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', height: '90vh'}} 
    >
        <p></p>
        <div style={{display: 'block', verticalAlign: 'middle', opacity: '0'}}>
            <p className="banner-title">LEGA PAUPER ITALIA</p>
        </div>
        <div className="indicator"></div>
    </div>
    <div style={{ textAlign: 'center', fontSize: '16px', marginBottom: '20px' }}>
      <Row className="content-body">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <h1>{t('common.about').toUpperCase()}</h1>
        </Col>
      </Row>
      <Row gutter={16} className="content-body" >
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <p style={{ fontSize: '16px' }}>
            {t('common.homeDesc1')}
          </p>
          <p style={{ fontSize: '16px' }}>
            {t('common.homeDesc2')}
          </p>
          <p style={{ fontSize: '16px' }}>
            {t('common.homeDesc3')}
          </p>
        </Col>
      </Row>
    </div>
    <div style={{ textAlign: 'center', fontSize: '16px', backgroundColor: '#001529' }}>
      <Row style={{ padding: '5px 50px', color: '#ffffff' }}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <h1>{t('common.quickActions').toUpperCase()}</h1>
        </Col>
      </Row>
      <Row style={{ padding: '5px 60px', justifyContent: 'space-evenly' }}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} style={{ alignItems: 'center' }} >
          <Link to={`${basepath}find-league`} viewTransition>
            <Card className="rules-card" title={<div style={{ whiteSpace: 'normal' }}>{t('leagues.join').toUpperCase()}</div>}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ fontSize: '90px', color: '578FCA', marginBottom: '30px' }}/>
              <h1 style={{ color: '#fff' }}>{t('leagues.find').toUpperCase()}</h1>
            </Card>
          </Link>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} style={{ alignItems: 'center' }}>
          <Link to={`${basepath}tournaments`} viewTransition>
            <Card className="rules-card" title={<div style={{ whiteSpace: 'normal' }}>{t('tournaments.attend').toUpperCase()}</div>}>
              <FontAwesomeIcon icon={faCalendarDays} style={{ fontSize: '90px', color: '578FCA', marginBottom: '30px' }}/>
              <h1 style={{ color: '#fff' }}>{t('tournaments.list').toUpperCase()}</h1>
            </Card>
          </Link>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} style={{ alignItems: 'center' }}>
          <Link to={`${basepath}rankings`} viewTransition>
            <Card className="rules-card" title={<div style={{ whiteSpace: 'normal' }}>{t('common.climbLadder').toUpperCase()}</div>}>    
                <FontAwesomeIcon icon={faRankingStar} style={{ fontSize: '90px', color: '578FCA', marginBottom: '30px' }}/>
                <h1 style={{ color: '#fff' }}>{t('menu.lpiranking').toUpperCase()}</h1>
            </Card>
          </Link>
        </Col>
      </Row>
    </div>
    <div style={{ textAlign: 'center', fontSize: '16px', marginBottom: '20px' }}>
      <Row className="content-body">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <h1>{t('common.upcomingEvents').toUpperCase()}</h1>
        </Col>
      </Row>
      <div className="slider-container" style={{ padding: '0 60px' }}>
        <Slider {...carouselSettings}>
          {
            upcoming.map(event => (
              <Link to ={`${basepath}tournaments/${event.id}`} viewTransition>
                <TournamentCard tournament={event} />
              </Link>
            ))
          }
        </Slider>
      </div>
    </div>
    </motion.div>
  );
}

export default Home;